import React from 'react';
import { Button } from 'react-bootstrap';
import { AlertTriangle, LogOut } from 'lucide-react';

interface ConnectAccountMismatchPanelProps {
    appUserEmail: string;
    onSignOut: () => void;
    isSigningOut?: boolean;
}

export function ConnectAccountMismatchPanel({
    appUserEmail,
    onSignOut,
    isSigningOut = false,
}: ConnectAccountMismatchPanelProps) {
    return (
        <div className="cw-account-mismatch cw-fade-in-up h-100 d-flex flex-column justify-content-center">
            <div className="cw-account-mismatch-card text-center mx-auto w-100">
                <div
                    className="cw-icon-circle mb-4 bg-light-danger text-danger mx-auto"
                    style={{ width: 64, height: 64 }}
                >
                    <AlertTriangle size={30} aria-hidden="true" />
                </div>
                <h4 className="fw-bold text-dark mb-2">Wrong Connect account</h4>
                <p className="text-muted fs-7 mb-4 px-2">
                    Sign out and log in to the CCP widget with the same Connect ID you used to
                    sign in to Adastra Connect.
                </p>

                {appUserEmail ? (
                    <p className="cw-account-mismatch-connect-id mb-4">
                        <span className="cw-account-mismatch-label">Your Connect ID</span>
                        <span className="cw-account-mismatch-value">{appUserEmail}</span>
                    </p>
                ) : null}

                <Button
                    variant="primary"
                    className="px-5 py-3 cw-action-btn fw-bold w-100"
                    style={{
                        backgroundColor: '#D7383C',
                        borderColor: '#D7383C',
                        boxShadow: '0 4px 14px rgba(215, 56, 60, 0.4)',
                    }}
                    onClick={onSignOut}
                    disabled={isSigningOut}
                    aria-label="Sign out of Connect and sign in with the correct Connect ID"
                >
                    <span className="d-inline-flex align-items-center justify-content-center gap-2">
                        <LogOut size={18} aria-hidden="true" />
                        {isSigningOut ? 'Signing out…' : 'Sign out of Connect'}
                    </span>
                </Button>
            </div>
        </div>
    );
}
